import { FC, useCallback } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import liff from '@line/liff';

import { usePageTitle } from 'hooks/usePageTitle';

import { Story as StoryFeature } from 'components/features/Story';

import styles from './Story.module.scss';

type StoryId = '1' | '2';

const isValidStoryId = (id: string | undefined): id is StoryId => {
  return id === '1' || id === '2';
};

export const Story: FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const redirect = queryParams.get('redirect') || false;

  const validStoryId = isValidStoryId(id) ? id : undefined;
  usePageTitle(`ストーリー${validStoryId ? ` 第${validStoryId}章` : ''}`);

  const handleClose = useCallback(async () => {
    if (redirect) {
      navigate(`/${redirect}`);
      return;
    }

    // 第1弾・第2弾の場合：LIFFブラウザなら閉じる、それ以外はホーム画面に遷移
    if (validStoryId === '1' || validStoryId === '2') {
      // LIFFブラウザなら閉じる、それ以外はトップ画面に遷移
      if (liff.isInClient()) {
        liff.closeWindow();
      } else {
        navigate('/');
      }
      return;
    }

    navigate('/home');
  }, [navigate, redirect, validStoryId]);

  return (
    <>
      <div className={styles.page}>
        <StoryFeature onNextPhase={handleClose} />
      </div>
    </>
  );
};
